export const getImageUrl = (thumbnailImageUrl?: string, imageSize = 250, ac?: boolean): string => {
  // If this is a URL from real data, it will start with `//`
  if (thumbnailImageUrl?.startsWith('//')) {
    const [withoutTimestamp] = thumbnailImageUrl.split(',');
    return withoutTimestamp.length > 0 ? `https:${withoutTimestamp}._${ac ? 'AC_' : ''}SS${imageSize}_.jpg` : thumbnailImageUrl;
  }

  return thumbnailImageUrl ?? '';
};

